import { Controller } from "stimulus";
import BootstrapNavTabs from "../entrypoints/src/admin/components/bootstrap_nav_bars";

export default class extends Controller {
  connect() {
    BootstrapNavTabs.mergeCustomFeatures(this.element.querySelector('.tr-nav'));
  }
};